import moment from 'moment';

export const getCallStatus = () => {
  const day = new Date().getDay();

  let hour = moment().tz('America/New_York').format('H');
  if (hour.toString().length < 2) {
    hour = `0${hour}`;
  }

  let minute = moment().tz('America/New_York').format('m');
  if (minute.toString().length < 2) {
    minute = `0${minute}`;
  }

  const timeOfDay = `${hour}:${minute}`;
  if (day === 3 && timeOfDay >= '12:15' && timeOfDay <= '14:00') {
    return 3;
  } else if (day === 4 && timeOfDay >= '12:45' && timeOfDay <= '14:00') {
    return 4;
  } else if (day === 5 && timeOfDay >= '09:45' && timeOfDay <= '11:00') {
    return 5;
  } else {
    return 0;
  }
};
